const projectsData = {
  moiraGoa: {
    title: "Moira Residence, Goa",
    location: "Moira, North Goa",
    year: "2024",
    description:
      "A tropical-modern residence designed on a lush Goan site with laterite textures, exposed concrete, and open courtyards.",

    gallery: [
      { src: "/images/projects/moira-goa/thumb.webp", viewTitle: "Backyard View", caption: "Entrance courtyard shaded by laterite walls and dense foliage." },
      { src: "/images/projects/moira-goa/3.webp", viewTitle: "Arched Facade", caption: "A sculpted concrete home embedded within a layered landscape, where arched openings, planted terraces, and screened façades soften the architecture and integrate it into its ecological setting." },
      { src: "/images/projects/moira-goa/1.webp", viewTitle: "Cantilevered Courtyard", caption: "A contemporary tropical home composed of layered concrete planes and deep overhangs, where shaded verandahs, perforated screens, and landscaped edges mediate light, privacy, and climate." },
      { src: "/images/projects/moira-goa/2.webp", viewTitle: "Garden Terrace Pavilion", caption: "An elevated living pavilion opening into a planted terrace, where full-height glazing and deep cantilevered roofs dissolve the boundary between interior space and the surrounding landscape." },
      { src: "/images/projects/moira-goa/12.webp", viewTitle: "River View", caption: "A tranquil infinity-edge pool aligned with the distant river valley, where reflective water surfaces extend the visual horizon and frame the surrounding landscape as part of the spatial experience." }
    ],

    additionalGallery: [
      "/images/projects/moira-goa/4.webp",
      "/images/projects/moira-goa/5.webp",
      "/images/projects/moira-goa/6.webp",
      "/images/projects/moira-goa/7.webp",
      "/images/projects/moira-goa/8.webp",
      "/images/projects/moira-goa/9.webp",
      "/images/projects/moira-goa/10.webp",
      "/images/projects/moira-goa/11.webp",
      "/images/projects/moira-goa/s1.webp",
      "/images/projects/moira-goa/s2.webp",
      "/images/projects/moira-goa/s3.webp",
      "/images/projects/moira-goa/s4.webp"
    ],

    video: { type: "local", src: "/images/projects/moira-goa/soon.mp4", thumbnail: "/images/projects/moira-goa/thumb.webp" },
    architects: ["Aditya Mehta", "Jahanzaib Bhat"]
  },

  sharanDelhi: {
    title: "Studio Sharan, New Delhi",
    location: "Greater Kailash, New Delhi",
    year: "2024",
    description:
      "A calm, material-driven meeting space where linear lighting, acoustic ceilings, and soft furnishings create a focused yet relaxed environment for collaboration, dialogue, and design review.",

    gallery: [
      { src: "/images/projects/studiosharan/thumb.webp", viewTitle: "Studio Entrance", caption: "Arrival sequence framed by concrete planes and filtered light." },
      { src: "/images/projects/studiosharan/1.webp", viewTitle: "Studio Conference Table", caption: "A composed front-of-house environment that blends hospitality and professionalism, where material textures, soft seating, and integrated presentation walls support client engagement and design discussion." },
      { src: "/images/projects/studiosharan/2.webp", viewTitle: "Rattan Acoustic Ceiling", caption: "The ceiling is conceived as a continuous rattan-lined surface suspended between structural beams, introducing warmth, texture, and acoustic softness into the studio environment." },
      { src: "/images/projects/studiosharan/3.webp", viewTitle: "Conference Lounge", caption: "A flexible meeting and lounge environment where formal review and informal conversation coexist, structured by a central worktable, soft perimeter seating, and a material palette that balances clarity, comfort, and focus." },
      { src: "/images/projects/studiosharan/4.webp", viewTitle: "Reception", caption: "A calm and welcoming entry space defined by a sculpted stone reception desk, soft seating, and a patterned backdrop that subtly frames the studio identity while maintaining a quiet, professional atmosphere." }
    ],

    additionalGallery: [
      "/images/projects/studiosharan/5.webp",
      "/images/projects/studiosharan/6.webp",
      "/images/projects/studiosharan/7.webp",
      "/images/projects/studiosharan/8.webp",
      "/images/projects/studiosharan/9.webp",
      "/images/projects/studiosharan/10.webp",
      "/images/projects/studiosharan/11.webp",
    ],

    video: { type: "local", src: "/images/projects/studiosharan/soon.mp4", thumbnail: "/images/projects/studiosharan/thumb.webp" },
    architects: ["Aditya Mehta", "Jahanzaib Bhat"]
  },

  siolimGoa: {
    title: "Siolim Residence, Goa",
    location: "Siolim, North Goa",
    year: "2023",
    description:
      "A compact tropical home responding to climate through shaded outdoor spaces and material honesty.",

    gallery: [
      { src: "/images/projects/siolim-goa/thumb.webp", viewTitle: "Front Elevation", caption: "Street-facing façade with deep overhangs and laterite walls." },
      { src: "/images/projects/siolim-goa/1.webp", viewTitle: "Stepped Facade", caption: "A sculptural coastal home defined by bold concrete volumes, deep horizontal overhangs, and expansive glazing, designed to balance privacy, shade, and long views within a tropical setting." },
      { src: "/images/projects/siolim-goa/5.webp", viewTitle: "Textured Metal Mural Wall", caption: "A sculptural feature wall composed of patinated metal forms layered over a textured plaster surface, creating a shifting interplay of light, shadow, and material depth that reads as both artwork and architecture." },
      { src: "/images/projects/siolim-goa/3.webp", viewTitle: "Reflective Courtyard", caption: "A serene courtyard house organized around a linear water body, where layered concrete volumes, reflective glazing, and tropical planting create a private, inward-looking domestic landscape." },
      { src: "/images/projects/siolim-goa/4.webp", viewTitle: "Horizon Frame", caption: "A horizontally layered coastal residence defined by deep concrete frames and expansive glazing, oriented to capture low-angle light, long views, and prevailing coastal breezes." }
    ],

    additionalGallery: [
      "/images/projects/siolim-goa/2.webp",
      "/images/projects/siolim-goa/6.webp",
      "/images/projects/siolim-goa/7.webp",
      "/images/projects/siolim-goa/8.webp",
      "/images/projects/siolim-goa/9.webp",
      "/images/projects/siolim-goa/10.webp",
      "/images/projects/siolim-goa/11.webp",
      "/images/projects/siolim-goa/12.webp"
    ],

    video: { type: "local", src: "/images/projects/siolim-goa/soon.mp4", thumbnail: "/images/projects/siolim-goa/thumb.webp" },
    architects: ["Aditya Mehta"]
  },

  safdarjungDelhi: {
    title: "Residence 816, New Delhi",
    location: "Safdarjung, New Delhi",
    year: "2023",
    description:
      "A compact tropical home responding to climate through shaded outdoor spaces and material honesty.",

    gallery: [
      { src: "/images/projects/safdarjung-delhi/thumb.webp", viewTitle: "Front Elevation", caption: "Street-facing façade with deep overhangs and laterite walls." },
      { src: "/images/projects/safdarjung-delhi/1.webp", viewTitle: "Perforated Screen", caption: "A contemporary residential building articulated by layered balconies and a perforated metal screen that filters light, enhances privacy, and gives the façade a distinctive climatic and visual identity." },
      { src: "/images/projects/safdarjung-delhi/2.webp", viewTitle: "Layered Urban Infill Residence", caption: "A mid-rise residential infill project that negotiates between contemporary concrete volumes and a retained historic façade, unified by a perforated brick screen that moderates light, scale, and privacy." },
      { src: "/images/projects/safdarjung-delhi/3.webp", viewTitle: "Living Room", caption: "A soft, light-filled living space organized around a central courtyard and filtered glazing, where minimal surfaces, warm timber elements, and natural light create a calm domestic atmosphere." },
      { src: "/images/projects/safdarjung-delhi/5.webp", viewTitle: "Rooftop Pavilion", caption: "A light, open rooftop structure combining concrete frames, pergola shading, and full-height glazing to create a social terrace that extends the living space into the landscape and sky." }
    ],

    additionalGallery: [
      "/images/projects/safdarjung-delhi/4.webp",
      "/images/projects/safdarjung-delhi/6.webp",
      "/images/projects/safdarjung-delhi/7.webp",
      "/images/projects/safdarjung-delhi/8.webp",
      "/images/projects/safdarjung-delhi/9.webp"
    ],

    video: { type: "local", src: "/images/projects/safdarjung-delhi/soon.mp4", thumbnail: "/images/projects/safdarjung-delhi/thumb.webp" },
    architects: ["Aditya Mehta"]
  },

  basement429: {
    title: "Residence 429, New Delhi",
    location: "Greater Kailash, New Delhi",
    year: "2023",
    description:
      "An open yet intimate underground lounge where layered seating zones, a textured feature wall, and a central bar create a sequence of spaces for gathering, conversation, and informal entertainment.",

    gallery: [
      { src: "/images/projects/429basement/thumb.webp", viewTitle: "Front Elevation", caption: "Street-facing façade with deep overhangs and laterite walls." },
      { src: "/images/projects/429basement/1.webp", viewTitle: "Subterranean Dining Lounge", caption: "A warm, intimate basement dining space defined by textured stone surfaces, soft indirect lighting, and a restrained material palette that transforms an underground level into a refined social environment." },
      { src: "/images/projects/429basement/2.webp", viewTitle: "Media Lounge", caption: "A cinematic underground retreat combining a bar, lounge seating, and a full-height projection wall, where layered lighting and tactile surfaces create an immersive, intimate environment for leisure and entertainment." },
      { src: "/images/projects/429basement/3.webp", viewTitle: "Sculpted Light Wall", caption: "A textured feature wall articulated through vertical relief cuts and concealed lighting, creating a soft play of shadow and depth that brings movement and tactility to an otherwise minimal interior setting." },
      { src: "/images/projects/429basement/5.webp", viewTitle: "Bar Lounge", caption: "A central sculpted bar anchors the basement entertainment space, where warm metals, stone textures, and soft perimeter lighting create a refined yet relaxed atmosphere for social gathering and informal events." }
    ],

    additionalGallery: [
      "/images/projects/429basement/4.webp",
      "/images/projects/429basement/7.webp",
      "/images/projects/429basement/8.webp",
      "/images/projects/429basement/9.webp",
      "/images/projects/429basement/10.webp",
      "/images/projects/429basement/11.webp",
    ],

    video: { type: "local", src: "/images/projects/429basement/soon.mp4", thumbnail: "/images/projects/429basement/thumb.webp" },
    architects: ["Aditya Mehta", "Jahanzaib Bhat"]
  }
};

export default projectsData;
